"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerInitials = void 0;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
const useCustomerInitials = () => {
  const {
    isAnonymousUser,
    isUserVerified,
    customerId
  } = (0, _auth.useToken)();
  const {
    data
  } = (0, _globalApiClientReact.useGetCustomerProfile)(customerId, undefined, {
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled: isUserVerified && !isAnonymousUser
    }
  });
  if (data) {
    const {
      firstName,
      lastName
    } = data;
    if (lastName) {
      return `${firstName ? firstName.charAt(0) : ''}${lastName.charAt(0)}`;
    }
  }
  return undefined;
};
exports.useCustomerInitials = useCustomerInitials;
